import React, { useState } from 'react';

import reloadTokens from '@amzn/meridian-tokens/base/icon/refresh';
import Alert from '@amzn/meridian/alert';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Loader from '@amzn/meridian/loader';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Tooltip from '@amzn/meridian/tooltip';

import { isNil } from 'lodash';
import { FileUploader } from 'src/components/Agreements/FileUploader';
import { SearchContextProvider } from 'src/components/Agreements/SearchContext';
import { useTitle } from 'src/hooks';

import { AgreementsTable } from './AgreementsTable';
import { SearchBar } from './SearchBar';
import './TagColors.scss';

interface IAgreements {
    licensors?: string[];
}

export const Agreements: React.FC<IAgreements> = (props) => {
    useTitle('All Agreements');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>();
    const [uploadCounter, setUploadCounter] = useState(0);

    const reloadButton = (
        <Tooltip position={'end'} title={'Reload'}>
            <Button
                aria-label={'reload'}
                size={'small'}
                type={'link'}
                onClick={() => setUploadCounter((prev) => prev + 1)}
            >
                <Icon tokens={reloadTokens} />
            </Button>
        </Tooltip>
    );

    return (
        <SearchContextProvider>
            <Column width={'100%'}>
                <Row widths={['fit', 'fill']}>
                    <Row>
                        <Text type={'h200'}>Agreements</Text>
                        {!isNil(errorMessage) && (
                            <Alert type={'error'} size={'small'}>
                                Failed to load all documents: {errorMessage}
                            </Alert>
                        )}
                    </Row>
                    <Row alignmentHorizontal={'end'}>
                        {loading ? <Loader type={'circular'} size={'small'} label={'file loader'} /> : reloadButton}
                        <FileUploader />
                    </Row>
                </Row>
                <Row widths={['fill']}>
                    <SearchBar setErrorMessage={setErrorMessage} setLoading={setLoading} />
                </Row>
                <AgreementsTable
                    setErrorMessage={setErrorMessage}
                    loading={loading}
                    setLoading={setLoading}
                    licensors={props.licensors}
                    uploadCounter={uploadCounter}
                />
            </Column>
        </SearchContextProvider>
    );
};

export interface IndexMetadata {
    readonly dataType: string;
    readonly colorClass: string;
}
